import { lazy } from 'react';

const QuoteExpiredContent = import(
  'components/direct-sales/quote-expired-revamp/components/QuoteExpiredContent'
);

export const RetrieveQuote = {
  Content: lazy(() => QuoteExpiredContent)
};

export default RetrieveQuote;
